/**
 * Wishlist Image Fix
 * Handles broken images in Zooomy wishlist by regenerating URLs from product data
 */

(function() {
  'use strict';

  const PLACEHOLDER_IMAGE = 'https://cdn.shopify.com/s/files/1/0608/8907/1747/files/placeholder_600x400_8474dce6-5161-44c6-a515-ec8f4ba6f854.svg?v=1730845211';
  const MAX_RETRIES = 2;

  function getProductIdFromGrid(gridElement) {
    if (!gridElement || !gridElement.id) return null;
    const match = gridElement.id.match(/ZoomyWishlistPageGrid-(\d+)/);
    return match ? match[1] : null;
  }

  function getProductHandleFromGrid(gridElement) {
    if (!gridElement) return null;
    const link = gridElement.querySelector('a[href*="/products/"]');
    if (link && link.href) {
      const match = link.href.match(/\/products\/([^?\/]+)/);
      return match ? match[1] : null;
    }
    return null;
  }

  async function regenerateImageUrl(productId, productHandle) {
    try {
      let product = null;
      
      if (productHandle) {
        try {
          const response = await fetch(`/products/${productHandle}.js`);
          if (response.ok) {
            product = await response.json();
          }
        } catch (e) {
        }
      }

      if (!product && productId) {
        try {
          const response = await fetch(`/products/${productId}.js`);
          if (response.ok) {
            product = await response.json();
          }
        } catch (e) {
        }
      }

      if (product && product.featured_image) {
        let imageUrl = product.featured_image;
        if (imageUrl.startsWith('//')) {
          imageUrl = 'https:' + imageUrl;
        }
        
        let newUrl = imageUrl.replace(/(\.(jpg|jpeg|png|gif|webp))/i, '_360x$1');
        
        if (!newUrl.includes('_360x') && !newUrl.includes('width=')) {
          if (newUrl.includes('cdn.shopify.com')) {
            newUrl = newUrl + (newUrl.includes('?') ? '&' : '?') + 'width=360';
          } else {
            newUrl = imageUrl.replace(/(\.(jpg|jpeg|png|gif|webp))/i, '_360x$1');
          }
        }
        
        return newUrl;
      }
    } catch (error) {
      console.warn('Failed to fetch product data:', error);
    }
    return null;
  }

  async function handleBrokenImage(img) {
    if (img.dataset.fixing || img.dataset.fixed) return;
    img.dataset.fixing = 'true';

    const gridElement = img.closest('.ZoomyWishlistPageGrid');
    if (!gridElement) {
      img.src = PLACEHOLDER_IMAGE;
      img.dataset.fixed = 'true';
      return;
    }

    const productId = getProductIdFromGrid(gridElement);
    const productHandle = getProductHandleFromGrid(gridElement);

    const newUrl = await regenerateImageUrl(productId, productHandle);
    
    if (newUrl) {
      if (newUrl.startsWith('//')) {
        newUrl = window.location.protocol === 'https:' ? 'https:' + newUrl : 'http:' + newUrl;
      }
      
      const testImg = new Image();
      testImg.onload = () => {
        img.src = newUrl;
        img.dataset.fixed = 'true';
        img.removeAttribute('data-fixing');
        img.removeAttribute('data-error');
      };
      testImg.onerror = () => {
        img.src = PLACEHOLDER_IMAGE;
        img.dataset.fixed = 'true';
        img.removeAttribute('data-fixing');
        img.removeAttribute('data-error');
      };
      testImg.src = newUrl;
    } else {
      img.src = PLACEHOLDER_IMAGE;
      img.dataset.fixed = 'true';
      img.removeAttribute('data-fixing');
    }
  }

  function isImageBroken(img) {
    if (!img.complete) return false;
    if (img.naturalWidth === 0 || img.naturalHeight === 0) return true;
    if (img.dataset.error) return true;
    return false;
  }

  function processWishlistImages() {
    const wishlistContainer = document.getElementById('ZoomyWishlistPage');
    if (!wishlistContainer) return;

    const images = wishlistContainer.querySelectorAll('img');
    images.forEach(img => {
      if (img.dataset.fixed || img.dataset.fixing) return;

      if (isImageBroken(img)) {
        handleBrokenImage(img);
      } else {
        img.addEventListener('error', function onError() {
          img.removeEventListener('error', onError);
          img.dataset.error = 'true';
          handleBrokenImage(img);
        }, { once: true });
      }
    });
  }

  function setupImageObserver() {
    const wishlistContainer = document.getElementById('ZoomyWishlistPage');
    if (!wishlistContainer) return;

    const observer = new MutationObserver((mutations) => {
      let hasNewImages = false;
      
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          if (node.nodeType === 1) {
            if (node.tagName === 'IMG') {
              hasNewImages = true;
            } else if (node.querySelector && node.querySelector('img')) {
              hasNewImages = true;
            }
          }
        });
      });

      if (hasNewImages) {
        setTimeout(processWishlistImages, 100);
      }
    });

    observer.observe(wishlistContainer, {
      childList: true,
      subtree: true
    });
  }

  function init() {
    if (document.getElementById('ZoomyWishlistPage')) {
      processWishlistImages();
      setupImageObserver();
    } else {
      const checkInterval = setInterval(() => {
        if (document.getElementById('ZoomyWishlistPage')) {
          clearInterval(checkInterval);
          processWishlistImages();
          setupImageObserver();
        }
      }, 500);

      setTimeout(() => clearInterval(checkInterval), 10000);
    }

    setTimeout(processWishlistImages, 2000);
    setTimeout(processWishlistImages, 5000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  window.addEventListener('pageshow', (event) => {
    if (event.persisted) {
      setTimeout(processWishlistImages, 100);
    }
  });
})();
